module.exports = __webpack_public_path__ + "static/media/ingenosya_logo.651e3d17.png";